import { useEffect, useMemo, useState } from "react";
import TeacherService from "../../services/TeacherService";
import { filterGroupsByIds } from "../../utils/occurrenceAdvanced";
import { ALL_REASONS_ID } from "./OccurrenceTypeFilters";

const countGroupReasons = groups =>
  groups.reduce(
    (total, group) =>
      total + (Array.isArray(group.reasons) ? group.reasons.length : 0),
    0
  );

export default function useOccurrenceTypeFilters(
  classId,
  allowedGroupIds = null
) {
  const [catalog, setCatalog] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [reasonId, setReasonId] = useState(ALL_REASONS_ID);

  useEffect(() => {
    let active = true;
    setLoaded(false);
    TeacherService.getOccurrenceTypes(classId)
      .then(types => {
        if (active) setCatalog(Array.isArray(types) ? types : []);
      })
      .catch(() => {
        if (active) setCatalog([]);
      })
      .then(() => {
        if (active) setLoaded(true);
      });
    return () => {
      active = false;
    };
  }, [classId]);

  const groups = useMemo(
    () =>
      allowedGroupIds ? filterGroupsByIds(catalog, allowedGroupIds) : catalog,
    [catalog, allowedGroupIds]
  );
  const groupLocked = !!allowedGroupIds && groups.length === 1;
  const reasonsHidden = useMemo(
    () => !!allowedGroupIds && countGroupReasons(groups) <= 1,
    [allowedGroupIds, groups]
  );

  const onGroupChange = group => {
    setSelectedGroup(group);
    setReasonId(ALL_REASONS_ID);
  };

  return {
    groups,
    loaded,
    groupLocked,
    reasonsHidden,
    selectedGroup: groupLocked ? groups[0] : selectedGroup,
    reasonId,
    onGroupChange,
    onReasonChange: setReasonId
  };
}
